import { useQuery } from '@tanstack/react-query';
import { apiService } from '../../services/api';
import { queryKeys } from './queryKeys';

export function useLeagueStandings(leagueId: string | undefined) {
  return useQuery({
    queryKey: queryKeys.leagueStandings(leagueId ?? ''),
    queryFn: () => apiService.getLeagueStandings(leagueId!),
    staleTime: 1 * 60 * 1000,
    enabled: !!leagueId,
  });
}
